/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const AlignHorizontalJustifyCenter = [
  "svg",
  defaultAttributes,
  [
    ["rect", { width: "6", height: "14", x: "2", y: "5", rx: "2" }],
    ["rect", { width: "6", height: "10", x: "16", y: "7", rx: "2" }],
    ["path", { d: "M12 2v20" }]
  ]
];

export { AlignHorizontalJustifyCenter as default };
//# sourceMappingURL=align-horizontal-justify-center.js.map
